import React, { useEffect } from "react";
import { useResetPasswordContext } from "context/reset-password-context";
import { brokenRule } from "utils/check-password";
import { InputGroupStyled } from "pages/login/style";
import CustomResetPasswordInput from "components/CustomPasswordsInput/ResetPassword/reset-password";
import { IErrorMessagePassword } from "models/login";
import ErrorInputMessage from "components/ErrorInputMessage/error-input-message";
import { useLoginContext } from "context/login-context";
import { ErrorMessageStyled } from "pages/login/style";

function InputResetPassword() {
  const { errorMessage } = useLoginContext();

  const {
    isSame,
    password,
    validation,
    setIsBtnDisabled,
    setIsSame,
  } = useResetPasswordContext();

  const passwordIsNotValid = brokenRule(validation) && password.newPass.length > 9;
  const passwordIsNotSame = !isSame && password.confirmPass.length > 9;

  useEffect(() => {
    const passwordIsInvalid = brokenRule(validation);
    if (password['confirmPass']) {
      if (isSame && !passwordIsInvalid) {
        setIsBtnDisabled(false);
      } else {
        setIsBtnDisabled(true);
      }
    } else {
      setIsBtnDisabled(true);
    }
  }, [isSame, validation, password['confirmPass']]);

  useEffect(() => {
    setIsSame(password.newPass === password.confirmPass);
  }, [password.newPass, password.confirmPass])

  return (
    <>
      <InputGroupStyled show={true}>
        <CustomResetPasswordInput
          label='Nova senha'
          passwordData={password.newPass}
          fieldName='newPass'
          error={passwordIsNotValid}
        />
        <ErrorInputMessage show={passwordIsNotValid} errorMessage={IErrorMessagePassword.SENHA_INVALIDA} />
        <ErrorMessageStyled>{errorMessage}</ErrorMessageStyled>
      </InputGroupStyled>

      <InputGroupStyled show={true}>
        <CustomResetPasswordInput
          label='Confirmar nova senha'
          passwordData={password.confirmPass}
          fieldName='confirmPass'
          error={passwordIsNotSame}
        />
        <ErrorInputMessage show={passwordIsNotSame} errorMessage={IErrorMessagePassword.SENHA_NAO_CONFIRMADA} />
      </InputGroupStyled>
    </>
  );
}

export default InputResetPassword;